import {
    MutationCache,
    Query,
    QueryCache,
    QueryClient,
    QueryKey
} from "@tanstack/react-query";

export type ReactQueryGlobalErrorHandler = (
    error: unknown,
    queryOrMutation?: Query<unknown, unknown, unknown, QueryKey>
) => void;

export const createQueryClient = (
    onQueryError: ReactQueryGlobalErrorHandler,
    onMutationError: ReactQueryGlobalErrorHandler
) => {
    return new QueryClient({
        queryCache: new QueryCache({
            onError: onQueryError
        }),
        mutationCache: new MutationCache({
            onError: (error) => {
                onMutationError(error);
            }
        }),
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: false,
                retry: false,
                cacheTime: 0
            }
        }
    });
};
